export const getPosterUrl = (mpdLink, quality) => {
  let posterUrl = `${mpdLink.split("/").slice(0, -1).join("/")}${mpdLink[0]
    .split("/")
    .slice(0, -1)
    .join("/")}/video_${quality}.jpg`;
  return posterUrl;
};
//        let posterUrl = `${this.dashSource[0].split('/').slice(0, -1).join('/')}/video_${quality}.jpg`
